<div #scrollContainer class="flex-grow rotate-180 overflow-auto px-5 pb-4 direction-rtl" (wheel)="onMouseWheel($event)">
  <div
    libInfiniteScrollList
    (startReached)="loadOlderMessages.emit()"
    class="flex min-h-full rotate-180 flex-col justify-end direction-ltr"
  >
    @if (showWelcome()) {
      <lib-assistant-welcome-banner
        [title]="welcomeTitle() ?? ('assistant_chat_window_welcome_title' | translate)"
        [description]="welcomeDescription() ?? ('assistant_chat_window_welcome_message' | translate)"
      ></lib-assistant-welcome-banner>
    }

    @for (message of messages(); track message.id) {
      @if (newMessageMarkerBeforeMessageId() === message.id) {
        <lib-new-message-marker class="py-4"></lib-new-message-marker>
      }

      @if ($index === 0 || (message.sentAt | datesHaveBiggerGap: messages()[$index - 1].sentAt)) {
        <div class="typo-h5-book mx-auto mt-3 flex gap-2 pt-2 text-text-light">
          <span>{{ message.sentAt | date: 'mediumDate' }}</span>
          <span>{{ message.sentAt | date: 'shortTime' }}</span>
        </div>
      }

      @if (message.isSystemMessage) {
        <div class="typo-h5-book mx-auto mt-3 flex gap-2 pt-2 text-text-light">
          {{ message.text }}
        </div>
      } @else {
        <lib-message
          [ngClass]="{
            'mt-3': message.showSender || !(message | messagesInSameThread: messages()[$index - 1]),
            'mt-1': (!message.showSender && !message.showAvatar) || (!message.showSender && message.showAvatar)
          }"
          libInfiniteScrollListItem
          [message]="message"
          [showSender]="message.showSender ?? true"
          [showAvatar]="message.showAvatar ?? true"
          [isSupportCollab]="true"
          [isChatWindow]="true"
          [participantCount]="participantCount()"
          [isCollabSoftDeleted]="false"
          [showParentMessage]="!!message.parentMessage && !(message | messagesInSameThread: messages()[$index - 1])"
          [editingMessageId]="editingMessageId()"
          [historyOpenMessageId]="historyOpenMessageId()"
          [quickActionContext]="quickActionContext()"
          (namedQuickAction)="namedQuickAction.emit($event)"
          (unsendMessage)="unsendMessage.emit(message.id)"
          (markMessageUnread)="markMessageUnread.emit(message.id)"
          (downloadTap)="onDownloadTap(message.id)"
          (downloadAttachments)="onDownloadAttachments()"
          (retrySendMessage)="retrySendMessage.emit($event)"
          (reply)="reply.emit(message)"
          (threadClicked)="threadClicked.emit(message)"
          (startEdit)="startEdit.emit($event)"
          (cancelEdit)="cancelEdit.emit()"
          (toggleHistory)="toggleHistory.emit($event)"
          (editMessage)="editMessage.emit($event)"
        ></lib-message>
      }

      @if (showSystemMessageAfter(message)) {
        <lib-assistant-system-message class="mt-3"></lib-assistant-system-message>
      }
    }
  </div>
</div>
